import { SessionList } from '../SessionList';

export enum SessionTypes {
  All = 'all',
  MatchingSessions = 'matching-sessions',
  MatchingClips = 'matching-clips',
}
export type SessionListItem = React.ComponentProps<typeof SessionList>['sessions'][0];
export type ClipListItem = React.ComponentProps<typeof SessionList>['clips'][0];
